export const getURL = (): string => {
  const url = process.env.NEXT_PUBLIC_SITE_URL
    ? process.env.NEXT_PUBLIC_SITE_URL
    : 'http://localhost:3000';
  return url.includes('http') ? url : `https://${url}`;
};

export const toDateTime = (secs: number): Date => {
  const t = new Date('1970-01-01T00:30:00Z'); // Unix epoch start.
  t.setSeconds(secs);
  return t;
};

export const classNames = (...classes: (string | undefined | null)[]): string => {
  return classes.filter(Boolean).join(' ');
};

export const renderCurrency = (amount: string, currency = 'USD'): string => {
  const currencySymbol = currency === 'USD' ? '$' : currency;
  return `${currencySymbol}${parseFloat(amount).toFixed(2)}`;
};

export const roundOffNumber = (amount: number): number => {
  return Math.round(amount * 100) / 100;
};

export const getMailgunMessageId = (messageId: string): string => {
  return messageId.replace('<', '').split('@')[0];
};

export const arrayJoinSeparator = <T>(array: T[], index: number): string => {
  if (array.length === 1) {
    return '';
  }

  return index === array.length - 1 ? ' and ' : ', ';
}

export const getUnixTimestamp = (date = new Date()): number => {
  return Math.floor(date.getTime() / 1000);
}
